import React from 'react'
import { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react'
import { organizationContext } from '../Organization/organizationContext';
import { RazerpayPayNow } from '../PaymentGateway/RazerpayPayNow';
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo';
import * as rechargeHistoryCrud from '../../../../configurations/crud/rechargeHistoryCrud'
import Card from '../../../controls/Card';
import { MdArrowBack, MdErrorOutline } from 'react-icons/md';
import { RechargeSmsPaymentSuccess } from './RechargeSmsPaymentSuccess';
import { RechargeSmsPaymentFailed } from './RechargeSmsPaymentFailed';
import { Link } from 'react-router-dom';
import useGlobalLoader from '../../../../configurations/useGlobalLoader';

export function DrapingRechargeSms({ setRechargePlan, data }) {
    const { start, end } = useGlobalLoader()
    // loadingMiniContext
    const [isLoadingMini, setIsLoadingMini] = useState(false)
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const [item, setItem] = useState(data)
    const [customerData, setCustomerData] = useState()
    const [isPaymentDone, setIsPaymentDone] = useState(false)
    const [isPaymentSuccess, setIsPaymentSuccess] = useState(true)
    const userData = getLoginInfo()
    const toast = useState()

    const GoToPlan = () => {
        setRechargePlan(0)
    }
    useEffect(() => {
        InitRechargeSms()
    }, [])

    function InitRechargeSms() {
        setIsLoadingMini(true);
        setIsLoadingLocal(true)
        start()
        rechargeHistoryCrud.InitRechargeSms(item.count)
            .then(res => {
                if (res.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data
                        setCustomerData({
                            amount: hdata.totalAmount,
                            description: "Payment For Recharge " + hdata.count + "  Sms.",
                            order_id: hdata.orderId,
                            customer_name: userData.fullName,
                            customer_email: userData.email,
                            customer_contact: userData.userName,
                            customer_address: userData.address,
                            rechargeId: hdata.rechargeId
                        })
                        setItem(hdata);
                        setIsLoadingMini(false)
                        setIsLoadingLocal(false)
                        end()
                    }
                    else {
                        setIsLoadingMini(false)
                        setIsLoadingLocal(false)
                        end()
                        setItem();
                    }
                }
                else {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false)
                    end()
                    setItem();
                    toast.open("Server Error /Invalid Try.", <MdErrorOutline />, 'error')

                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                setIsLoadingLocal(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const SuccessCall = (paymentid, orderid, signature) => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true)
        start()
        rechargeHistoryCrud.AfterRechargeSms(item.rechargeId, paymentid, signature)
            .then(res => {
                if (res.data) {
                    if (res.data.succeeded) {
                        setIsPaymentDone(true)
                        setIsPaymentSuccess(true)
                        setIsLoadingMini(false)
                        setIsLoadingLocal(false)
                        end()
                    }
                    else {
                        setIsPaymentDone(true)
                        setIsPaymentSuccess(false)
                        setIsLoadingMini(false)
                        setIsLoadingLocal(false)
                        end()
                    }
                }
                else {
                    setIsPaymentDone(true)
                    setIsPaymentSuccess(false)
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false)
                    end()
                    toast.open("Server Error /Invalid Try.", <MdErrorOutline />, 'error')
                }
            })
            .catch(error => {
                setIsPaymentDone(true)
                setIsPaymentSuccess(false)
                setIsLoadingMini(false);
                setIsLoadingLocal(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }
    const FailedCall = (message, paymentid) => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true)
        start()
        rechargeHistoryCrud.FailedRechargeSms(item.rechargeId, paymentid, message)
            .then(res => {
                if (res.data) {
                    if (res.data.succeeded) {
                        setIsPaymentDone(true)
                        setIsPaymentSuccess(false)
                        setIsLoadingMini(false)
                        setIsLoadingLocal(false)
                        end()
                    }
                    else {
                        setIsPaymentDone(true)
                        setIsPaymentSuccess(false)
                        setIsLoadingMini(false)
                        setIsLoadingLocal(false)
                        end()
                    }
                }
                else {
                    setIsPaymentDone(true)
                    setIsPaymentSuccess(false)
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false)
                    end()
                    toast.open("Server Error /Invalid Try.", <MdErrorOutline />, 'error')
                }
            })
            .catch(error => {
                setIsPaymentDone(true)
                setIsPaymentSuccess(false)
                setIsLoadingMini(false);
                setIsLoadingLocal(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    return (
        <>
            {isPaymentDone ?
                <>
                    {isPaymentSuccess ?
                        <RechargeSmsPaymentSuccess>
                            <h2>Recharge for <b>{item.count} Sms</b> has been successfull done.</h2>
                        </RechargeSmsPaymentSuccess>
                        :
                        <RechargeSmsPaymentFailed setRechargePlan={setRechargePlan}>
                            <h2>Recharge for <b>{item.count} Sms</b> has been failed.</h2>
                        </RechargeSmsPaymentFailed>
                    }
                </>
                :
                <>
                    {item &&
                        <div class="min-h-screen flex flex-col w-full md:px-8">
                            <Card
                                isBorder={true}
                                title={
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                                        <div className="flex items-center gap-1 text-blue-600 cursor-pointer" onClick={GoToPlan}>
                                            <MdArrowBack />
                                            <span>Back To Plan</span>
                                        </div>
                                        <div className="text-md">
                                            |  Recharge For <b>{item.count} SMS</b>
                                        </div>
                                        <div className="text-sm">
                                            <span className="font-semibold text-gray-700">Receipt:</span>
                                            <span className="text-green-600 ml-1">#{userData.userName}_{item.rechargeId}</span>
                                        </div>
                                    </div>
                                }
                            >
                            </Card>


                            <main class="flex-grow">
                                <Card>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                                        <div>
                                            <h2 class="text-base font-medium text-gray-800 mb-2 border-l-4 border-blue-600 pl-2">Company Info</h2>
                                            <ul class="space-y-1 text-gray-700 text-sm list-disc list-inside">
                                                <li>CUBICLE8 (Cubicle Eight)</li>
                                                <li>8, Anjum Manzil, Mau-275101</li>
                                                <li>Uttar Pradesh, INDIA</li>
                                                <li>PHONE: <span class="text-red-600">+91 95599 52123</span></li>
                                                <li>GSTIN: <span class="text-red-600">09AVBPA6995Q1ZS</span></li>
                                            </ul>
                                        </div>

                                        <div>
                                            <h2 class="text-base font-medium text-gray-800 mb-2 border-l-4 border-green-600 pl-2">Customer Info</h2>
                                            <ul class="space-y-1 text-gray-700 text-sm list-disc list-inside">
                                                <li>{userData.fullName}</li>
                                                <li>{userData.address}</li>
                                                <li>Uttar Pradesh</li>
                                                <li> Phone: <b class="red">{userData.userName}</b></li>
                                                <li>GSTIN: N/A</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>

                                <div class="bg-white p-4 shadow-sm mt-4">
                                    <h2 class="text-base font-medium text-gray-800 mb-3">Payment Info</h2>
                                    <table class="w-full text-gray-700 text-sm">
                                        <thead>
                                            <tr class="border-b">
                                                <th class="text-left py-1">#</th>
                                                <th class="text-left py-1">Description</th>
                                                <th class="text-right py-1">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="border-b">
                                                <td class="py-1">1</td>
                                                <td class="py-1">SMS Count</td>
                                                <td class="text-right py-1">₹{item.count}</td>
                                            </tr>
                                            <tr class="border-b">
                                                <td class="py-1">2</td>
                                                <td class="py-1">Per SMS Rate <small>(inclusive gst)</small></td>
                                                <td class="text-right py-1">₹{Number(item.perSmsRate).toFixed(2)}</td>
                                            </tr>
                                            <tr class="border-b">
                                                <td class="py-1">3</td>
                                                <td class="py-1">Net Amount</td>
                                                <td class="text-right py-1">₹{Number(item.netAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr class="border-b">
                                                <td class="py-1">4</td>
                                                <td class="py-1">GST %</td>
                                                <td class="text-right py-1">{item.gstSlab}%</td>
                                            </tr>
                                            <tr>
                                                <td class="py-1">5</td>
                                                <td class="py-1">GST AMOUNT</td>
                                                <td class="text-right py-1">₹{Number(item.gstAmount).toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="mt-4 text-gray-600 text-sm">
                                    <p class="font-medium">EXTRA INFORMATION:</p>
                                    <p class="mt-1">Note: Clicking on pay now will automatically accepts <Link to="/terms" class="text-blue-600">Terms & Conditions</Link></p>
                                </div>

                                <div class="flex justify-between items-center mt-4 p-3 bg-white shadow-sm">
                                    <p class="text-base font-medium text-gray-800">Total Amount: <span class="text-red-600">₹{Number(item.totalAmount).toFixed(2)}</span></p>
                                    <span className="pull-right">
                                        {isLoadingLocal ?
                                            <button class="btn btn-sm btn-blue-disabled" disabled>
                                                <i class="ace-icon fa fa-check"></i>
                                                Please wait
                                            </button>
                                            :
                                            <RazerpayPayNow SuccessCall={SuccessCall} FailedCall={FailedCall} data={customerData} />
                                        }
                                    </span>
                                </div>

                                <p class="mt-4 text-gray-600 text-center text-sm">
                                    Thank you for choosing Doctora Powered by Cubicle Eight products. We believe you will be satisfied by our services.
                                </p>
                            </main>
                        </div>
                    }
                </>
            }
        </>
    )
}
